import {
	BrowserRouter as Router,
	Switch,
	Route,
} from "react-router-dom";

import Dashboard from '../dashboard/Dashboard';
import Admin from "../admin/Admin";
import NotFound from "../not-found/NotFound";
import GoalView from '../goals/GoalView';
import GoogleAnalyticsListener from "../googleAnalytics/GoogleAnalyticsListener";
//@ts-ignore
import './app.scss';

const App = () => {
	const pathname = window.location.pathname;
	if (pathname === '/') {
		window.location.pathname = "/admin";
		return <div></div>;
	}

	return (
		<div className="App">
			<Router>
				<GoogleAnalyticsListener/>
				<Switch>
					<Route exact path="/dashboards/:id" component={Dashboard}/>
					<Route exact path="/admin" component={Admin}/>
					<Route exact path="/goals/:id" component={GoalView}/>
					<Route component={NotFound}/>
				</Switch>
			</Router>
		</div>
	);
}

export default App
